/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { Fragment, useEffect, useState } from "react";
import "../EMPAttendance/EMPattendance.css";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import Modal from "react-bootstrap/Modal";

import {
  Apiurl,
  GetToken,
  RemoveUserSession,
} from "../../../Utils/utils";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../../../Components/loader/loader";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Button, Offcanvas } from "react-bootstrap";
import { IoIosFunnel } from "react-icons/io";

function OffCanvasExample({ setShow, show, setActiveButton, handleAttendanceSearch, currentDate, setSearchAttendance, searchAttendance, activeButton, handleClick, name, ...props }) {

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button className="HideButton-on-web" variant="primary" onClick={handleShow} >
        <IoIosFunnel />
      </Button>
      <Offcanvas className="Offcanvas-main-container" show={show} onHide={handleClose} {...props}>
        <Offcanvas.Header className="Offcanvas-outter-container" closeButton>
          <Offcanvas.Title>Offcanvas</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="Offcanvas-Body-container">
          <div className="Offcanvas-close-popup-forEMp-attendance">
            <div className="Offcanvas-Div" onClick={handleClose}></div>
          </div>
          <div className="EMP-search-filter-all-button-for-mobile-view">
            <button
              className={`EMP-search-Filter-sheet-unactive ${activeButton === 7 ? "active" : ""
                }`}
              onClick={() => handleClick(7)}
              style={{
                backgroundColor: activeButton === 7 ? "#3f51b5" : "#ffffff",
                color: activeButton === 7 ? "#ffffff" : "#171718",
              }}
            >
              Last 7 Days
            </button>
            <button
              className={`EMP-search-Filter-sheet-unactive ${activeButton === 30 ? "active" : ""
                }`}
              onClick={() => handleClick(30)}
              style={{
                backgroundColor:
                  activeButton === 30 ? "#3f51b5" : "#ffffff",
                color: activeButton === 30 ? "#ffffff" : "#171718",
              }}
            >
              Last 30 Days
            </button>
            <button
              className={`EMP-search-Filter-sheet-unactive ${activeButton === 90 ? "active" : ""
                }`}
              onClick={() => handleClick(90)}
              style={{
                backgroundColor:
                  activeButton === 90 ? "#3f51b5" : "#ffffff",
                color: activeButton === 90 ? "#ffffff" : "#171718",
              }}
            >
              Last 3 Months
            </button>
            <button
              className={`EMP-search-Filter-sheet-unactive ${activeButton === 180 ? "active" : ""
                }`}
              onClick={() => handleClick(180)}
              style={{
                backgroundColor:
                  activeButton === 180 ? "#3f51b5" : "#ffffff",
                color: activeButton === 180 ? "#ffffff" : "#171718",
              }}
            >
              Last 6 Months
            </button>
            <button
              className={`EMP-search-Filter-sheet-unactive ${activeButton === 365 ? "active" : ""
                }`}
              onClick={() => handleClick(365)}
              style={{
                backgroundColor:
                  activeButton === 365 ? "#3f51b5" : "#ffffff",
                color: activeButton === 365 ? "#ffffff" : "#171718",
              }}
            >
              Last 12 Months
            </button>
          </div>
          <div className="calender-in-header-for-mobile-view row ">
            <div className="col-4">
              <div className="EMP-flash-floating-sheet col">
                <label htmlFor=""> Choose start date </label>
                <input
                  type="date"
                  name=""
                  id=""
                  value={searchAttendance?.startDate}
                  onChange={(e) =>
                    setSearchAttendance({
                      ...searchAttendance,
                      startDate: e?.target?.value,
                    })
                  }
                  max={currentDate}
                />
              </div>
            </div>
            <div className="col-4">
              <div className="flash-floating-sheet col">
                <label htmlFor=""> Choose end date </label>
                <input
                  type="date"
                  name=""
                  id=""
                  value={searchAttendance?.endDate}
                  // min={searchAttendance?.startDate}
                  onChange={(e) =>
                    setSearchAttendance({
                      ...searchAttendance,
                      endDate: e?.target?.value,
                    })
                  }
                  min={searchAttendance?.startDate}
                  max={currentDate}
                />
              </div>
            </div>
            {activeButton ||
              (searchAttendance?.startDate && searchAttendance?.endDate) ? (
              <div className=" EMP-search-button-sheet col-4">
                <button
                  onClick={() => {
                    setSearchAttendance({
                      startDate: "",
                      endDate: "",
                      dayscount: "",
                    });
                    setActiveButton();
                    handleAttendanceSearch();
                  }}
                >
                  Reset
                </button>
              </div>
            ) : null}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

const EMPattendance = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const currentDate = new Date().toISOString().split("T")[0];
  // const getUserRole = GetLoginRole();
  const [userNameHr, setUserNameHr] = useState();
  const [todayDate, setTodayDate] = useState(getTodayDate());
  // const [showManualAttendance, setShowManualAttendance] = useState(false);
  const [updateAttend, setupdateAttend] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const [activeButton, setActiveButton] = useState();
  const [monthResult, setMonthResult] = useState();
  const [searchAttendance, setSearchAttendance] = useState({
    startDate: "",
    endDate: "",
    dayscount: "",
  });
  const [inTimeHr, setInTimeHr] = useState();
  const [outTimeHr, setOutTimeHr] = useState();
  const [showModal, setShowModal] = useState(false);
  const [Modaldata, setmodaldata] = useState();
  const [modaldatanew, setmodaldatanew] = useState("");

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const [hrAddingData, setHrAddingData] = useState({
    Username: "",
    date: todayDate,
    WorkDuration: "",
    Status: "",
  });

  useEffect(() => {
    if (userNameHr) {
      setHrAddingData({ ...hrAddingData, Username: userNameHr });
    }
  }, [userNameHr]);

  function getTodayDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const handleClick = (index) => {
    setLoading(true);
    setShow(false)
    const data = {
      startDate: "",
      endDate: "",
      dayscount: index,
    };
    handleAttendanceSearch(data);
    setActiveButton(index);
  };

  const handleAttendanceSearch = (e) => {
    setLoading(true);
    const LoginToken = GetToken();
    const data = {
      startDate: e?.startDate || "",
      endDate: e?.endDate || "",
      dayscount: e?.dayscount || "",
    };
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Attendence/GetAttendanceByDateRange`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        setShow(false)
        const data = JSON.parse(e?.data?.data);
        const newData = data?.Result?.reduce((result, currentItem) => {
          const date = new Date(currentItem.Date);
          const month = date.getMonth() + 1;
          result[month - 1] = result[month - 1] || [];
          result[month - 1].push(currentItem);
          return result;
        }, []);
        const finalData = newData?.filter((item) => item?.length > 0);
        finalData.sort((a, b) => {
          const monthA = new Date(a[0].Date).getMonth();
          const monthB = new Date(b[0].Date).getMonth();
          const dayA = new Date(a[0].Date).getDate();
          const dayB = new Date(b[0].Date).getDate();
          if (monthA === monthB) {
            return dayB - dayA;
          }
          const currentDate = new Date();
          const currentMonth = currentDate.getMonth();
          if (monthA === currentMonth) {
            return -1;
          } else if (monthB === currentMonth) {
            return 1;
          }
          return monthB - monthA;
        });
        setMonthResult(finalData);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);

        if (error?.response?.status === 401) {
          toast.error("Your session has expired");
          RemoveUserSession();
          navigate("/", { replace: true });;
        }
      });
  };
  useEffect(() => {
    if (searchAttendance?.startDate && searchAttendance?.endDate) {
      setActiveButton(1);
      const data = {
        startDate: searchAttendance?.startDate,
        endDate: searchAttendance?.endDate,
        dayscount: "",
      };
      handleAttendanceSearch(data);
    } else {
      handleAttendanceSearch();
    }
  }, [searchAttendance?.endDate]);
  const monthsArray = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // const handleAddInputsClick = () => {
  //   setShowManualAttendance(true);
  // };
  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  const groupByDateWithPunch = (records) => {
    const grouped = {};

    records?.forEach((item) => {
      const dateKey = moment(item.Date).format("YYYY-MM-DD");

      if (!grouped[dateKey]) {
        grouped[dateKey] = {
          main: null,
          extras: [],
        };
      }

      if (item.IsMainPunch === false) {
        grouped[dateKey].extras.push(item);
      } else {
        grouped[dateKey].main = item;
      }
    });

    return Object.values(grouped);
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "Absent":
        return "status-absent";

      case "Holiday":
        return "status-holiday";

      case "WeeklyOFF":
        return "status-weekoff";

      case "SickLeave":
        return "status-sick";

      case "CasualLeave":
        return "status-casual";

      case "HalfDayleave":
        return "status-halfday";

      case "ShortLeave":
        return "status-shortleave";

      case "ThreeQuareterLeave":
        return "status-shortwork";

      case "OutDoorDuty":
        return "status-outdoor";

      case "FullDay":
      case "EarlyClosure":
        return "status-present";

      default:
        return "";
    }
  };

  return (
    <div>
      {loading ? <Loader /> : null}
      <Header
        showSidebar={showSidebar}
        setShowSidebar={setShowSidebar}
        setUserNameHr={setUserNameHr}
      />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />
        <div
          className={
            showSidebar
              ? "EMP-main-container-of-all-employees-sheet"
              : "EMP-main-container-of-all-employees-page-new-sheet"
          }
        >
          <div className="EMP-inner-container-of-all-employees-page ">
            <div className="header-of-employees-page row">
              <div className="EMP-all-employee-sheet col">
                <h4>Attendance Sheet</h4>
                <OffCanvasExample currentDate={currentDate} setActiveButton={setActiveButton} handleAttendanceSearch={handleAttendanceSearch}
                  setSearchAttendance={setSearchAttendance}
                  searchAttendance={searchAttendance} show={show} setShow={setShow}
                  handleClick={handleClick} activeButton={activeButton} placement="bottom" name="Open Bottom" />
              </div>
              <div className="EMP-all-employees-sheet col">
                <div className="EMP-home-icon-sheet">
                  <BiHomeAlt className="EMP-home-icon-header-sheet" />
                </div>
                <div className="EMP-arrow-icon-sheet">
                  <MdKeyboardArrowRight />
                </div>
                <div className="EMP-employee-text-sheet">
                  <p>Attendance</p>
                </div>
                <div className="EMP-arrow-icon-sheet">
                  <MdKeyboardArrowRight />
                </div>
                <div className="EMP-all-employee-text-sheet">
                  <p>Attendance Sheet</p>
                </div>
              </div>
            </div>
          </div>
          <div className="EMP-body-part-outer-sheet">
            <div className="EMP-attandance-sheet-head">
              <div className="top-legends-main">

                <div className="legends-section sticky-legends">

                  <div className="legend-item status-present">Present</div>

                  <div className="legend-item status-absent">Absent</div>

                  <div className="legend-item status-holiday">Holiday</div>

                  <div className="legend-item status-weekoff">Weekly Off</div>

                  <div className="legend-item status-sick">Sick Leave</div>

                  <div className="legend-item status-casual">Casual Leave</div>

                  <div className="legend-item status-halfday">Half Day</div>

                  <div className="legend-item status-shortleave">Short Leave</div>

                  <div className="legend-item status-shortwork">Short Work</div>

                  <div className="legend-item status-outdoor">Outdoor Duty</div>

                </div>
              </div>
            </div>
            <div className="EMP-table-in-all-emplyee-sheet">

              <div className="EMP-search-filter-all-button">
                <button
                  className={`EMP-search-Filter-sheet-unactive ${activeButton === 7 ? "active" : ""
                    }`}
                  onClick={() => handleClick(7)}
                  style={{
                    backgroundColor: activeButton === 7 ? "#3f51b5" : "#ffffff",
                    color: activeButton === 7 ? "#ffffff" : "#171718",
                  }}
                >
                  Last 7 Days
                </button>
                <button
                  className={`EMP-search-Filter-sheet-unactive ${activeButton === 30 ? "active" : ""
                    }`}
                  onClick={() => handleClick(30)}
                  style={{
                    backgroundColor:
                      activeButton === 30 ? "#3f51b5" : "#ffffff",
                    color: activeButton === 30 ? "#ffffff" : "#171718",
                  }}
                >
                  Last 30 Days
                </button>
                <button
                  className={`EMP-search-Filter-sheet-unactive ${activeButton === 90 ? "active" : ""
                    }`}
                  onClick={() => handleClick(90)}
                  style={{
                    backgroundColor:
                      activeButton === 90 ? "#3f51b5" : "#ffffff",
                    color: activeButton === 90 ? "#ffffff" : "#171718",
                  }}
                >
                  Last 3 Months
                </button>
                <button
                  className={`EMP-search-Filter-sheet-unactive ${activeButton === 180 ? "active" : ""
                    }`}
                  onClick={() => handleClick(180)}
                  style={{
                    backgroundColor:
                      activeButton === 180 ? "#3f51b5" : "#ffffff",
                    color: activeButton === 180 ? "#ffffff" : "#171718",
                  }}
                >
                  Last 6 Months
                </button>
                <button
                  className={`EMP-search-Filter-sheet-unactive ${activeButton === 365 ? "active" : ""
                    }`}
                  onClick={() => handleClick(365)}
                  style={{
                    backgroundColor:
                      activeButton === 365 ? "#3f51b5" : "#ffffff",
                    color: activeButton === 365 ? "#ffffff" : "#171718",
                  }}
                >
                  Last 12 Months
                </button>
              </div>
              <div className="calender-in-header row ">
                <div className="col-4">
                  <div className="EMP-flash-floating-sheet col">
                    <label htmlFor=""> Choose start date </label>
                    <input
                      type="date"
                      name=""
                      id=""
                      value={searchAttendance?.startDate}
                      onChange={(e) =>
                        setSearchAttendance({
                          ...searchAttendance,
                          startDate: e?.target?.value,
                        })
                      }
                      max={currentDate}
                    />
                  </div>
                </div>
                <div className="col-4">
                  <div className="flash-floating-sheet col">
                    <label htmlFor=""> Choose end date </label>
                    <input
                      type="date"
                      name=""
                      id=""
                      value={searchAttendance?.endDate}
                      // min={searchAttendance?.startDate}
                      onChange={(e) =>
                        setSearchAttendance({
                          ...searchAttendance,
                          endDate: e?.target?.value,
                        })
                      }
                      min={searchAttendance?.startDate}
                      max={currentDate}
                    />
                  </div>
                </div>
                {activeButton ||
                  (searchAttendance?.startDate && searchAttendance?.endDate) ? (
                  <div className=" EMP-search-button-sheet col-4">
                    <button
                      onClick={() => {
                        setSearchAttendance({
                          startDate: "",
                          endDate: "",
                          dayscount: "",
                        });
                        setActiveButton();
                        handleAttendanceSearch();
                      }}
                    >
                      Reset
                    </button>
                  </div>
                ) : null}
              </div>

              <div className="EMP-table-all-content-sheet">
                {monthResult?.map((e, index) => {
                  return (
                    <Fragment key={index}>
                      <div className="months-heading-for-table">
                        <p>
                          {`${monthsArray[new Date(e?.[0]?.Date)?.getMonth()]
                            } ${new Date(e?.[0]?.Date)?.getFullYear()}`}
                        </p>
                      </div>
                      <table className="EMP-table-main-class">
                        <thead className="EMP-thead-main-class">
                          <tr className=" ewfef row"></tr>
                          <tr className="">
                            <th className="day-and-date-label">
                              <p>Date</p>
                              <p>Day</p>
                            </th>
                            {groupByDateWithPunch(e)?.map((group, index) => {
                              const item = group.main || group.extras[0];
                              if (!item) return null;

                              return (
                                <td
                                  key={index}
                                  style={{ position: "relative" }}
                                >
                                  {new Date(item.Date).toLocaleDateString("en-US", {
                                    weekday: "short",
                                    day: "numeric",
                                  })}

                                  {group.extras.length > 0 && (
                                    <div
                                      className="extra-count-badge"
                                      title={group.extras
                                        .map(
                                          (ex) =>
                                            `In: ${ex?.InTime?.substring(0, 5) || "-"} | Out: ${ex?.OutTime?.substring(0, 5) || "-"
                                            }`
                                        )
                                        .join("\n")}
                                    >
                                      +{group.extras.length}
                                    </div>
                                  )}
                                </td>
                              );
                            })}
                          </tr>
                        </thead>
                        <tbody className="EMP-tbody-main-class">
                          <tr>
                            <td className="input-class-in-td-main ">
                              <p className="attendance-label">Attendance</p>
                              <p className="in-time-label">In time</p>
                              <p className="outtime-label">Out time</p>
                            </td>
                            {groupByDateWithPunch(e)?.map((group, index) => {
                              const item = group.main || group.extras[0];
                              if (!item) return null;

                              return (
                                <td
                                  key={index}
                                  className={`attendance-cell ${getStatusClass(item.DailyStatus)}`}
                                >
                                  <p className="intime-for-attendance" style={{
                                    color: !item?.DailyStatus || item?.DailyStatus === "" ? "black" : "white",
                                  }}>
                                    {item?.InTime ? item.InTime.substring(0, 5) : "-"}
                                  </p>
                                  <p className="out-for-attendance" style={{
                                    color: !item?.DailyStatus || item?.DailyStatus === "" ? "black" : "white",
                                  }}>
                                    {item?.OutTime ? item.OutTime.substring(0, 5) : "-"}
                                  </p>
                                </td>
                              );
                            })}
                          </tr>
                        </tbody>
                      </table>
                    </Fragment>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EMPattendance;